import Immutable from 'seamless-immutable'
import Api from '../lib/api'
import organizations from '../pages/organizations';

export const SET_ORGANIZATIONS = 'SET_ORGANIZATIONS'
export const SET_ORGANIZATION = 'SET_ORGANIZATION'
export const ADD_ORGANIZATION = 'ADD_ORGANIZATION'
export const UPDATE_ORGANIZATION = 'UPDATE_ORGANIZATION'
export const DELETE_ORGANIZATION = 'DELETE_ORGANIZATION'

export const loadOrganizations =({perPage = 100, page, workspaceId, search, sortBy, sortDirection} = {})=>{
    return async (dispatch) => {

        let {organizations, total} = await Api.getOrganizations({perPage, page, workspaceId, search, sortBy, sortDirection})
        dispatch({
            type: SET_ORGANIZATIONS,
            organizations,
            organizationsCount: total
        })
    }
}

export const loadOrganization = ({organizationId})=>{
    return async (dispatch)=>{
        let organization = await Api.getOneOrganization({organizationId})
        dispatch({
            type: SET_ORGANIZATION,
            organization
        })
    }
}

export const updateOrganization = ({organization, name})=>{
    return async (dispatch) =>{
        let update = await Api.updateOrganization({organizationId: organization.id, name})
        if(update){
            dispatch({
                type: UPDATE_ORGANIZATION,
                organizationId: organization.id,
                data: update
            })
        }
        
        return update
    }
}

export const createOrganization = ({name})=>{
    return async (dispatch)=>{
        let organization = await Api.createOrganization({
            name,
            workspaceId:1
        })
        console.log('created organization', organization)
        if(organization){
            dispatch({
                type: ADD_ORGANIZATION,
                organization
            })
        }
        return organization
        
    }
}

export const deleteOrganization = ({organization})=>{
    return async (dispatch)=>{
        let removed = await Api.deleteOrganization({organizationId: organization.id})
        if(removed){
            dispatch({
                type: DELETE_ORGANIZATION,
                organization
            })
        }
    }
}

const updateOrganizationInState = ({state, action})=>{
    const {organizationId, data} = action
    let organizations = state.organizations.map((organization)=>{
        if(organization.id === organizationId){
            return organization.merge(data)
        }
        return organization
    })
    state = state.set('organizations', organizations)
    if(state.organization && state.organization.id === organizationId){
        state = state.set('organization', state.organization.merge(data))
    }
    return state
}


const initialState = Immutable({users: []})

export const reducer = (state = initialState, action)=>{

    switch (action.type) {

    case SET_ORGANIZATIONS:
        return state.set('organizations', action.organizations).set('organizationsCount', action.organizationsCount)
    case SET_ORGANIZATION:
        return state.set('organization', action.organization)
    case UPDATE_ORGANIZATION:
        return updateOrganizationInState({state, action})
    case DELETE_ORGANIZATION:
        return state.set('organizations', state.organizations.filter((organization)=>{
            return organization.id !== action.organization.id
        }))
    case ADD_ORGANIZATION:
        return state.set('organizations', [action.organization].concat(state.organizations))
    default:
        return state
    }

}



// WEBPACK FOOTER //
// ./src/actions/organizations.js